import { addApiPrefix } from 'as-ui-kit/utils/urls';
import { getFetchOptions, handleResult } from 'as-ui-kit/utils/http';
import { snakeToPascalObj } from 'as-ui-kit/utils/adapters';
import { catchWithMsg } from 'utils/http';

export const getIcons = (rq, appUrl, lang) =>
    fetch(addApiPrefix(`/icons/v1/?iconTypes=2527&lang=${lang}`, appUrl), getFetchOptions(rq, 'POST'))
        .then(handleResult)
        .then(ret => snakeToPascalObj(ret, true))
        .catch(catchWithMsg);
